/* global jQuery */

export default class VonqChannelSelector {
  static selectorString() {
    return '.VonqChannelSelector';
  }

  render(node, props) {
    this.filterNameInput = node.querySelector('[name="name"]');
    this.filterLocationInput = node.querySelector('[name="location"]');

    this.filterNameInput.addEventListener('keyup', this.clearLocation.bind(this));
    this.filterNameInput.addEventListener('change', this.clearLocation.bind(this));

    this.filterLocationInput.addEventListener('keyup', this.clearName.bind(this));
    this.filterLocationInput.addEventListener('change', this.clearName.bind(this));
    jQuery(this.filterLocationInput)
      .on('select2:select', this.clearName.bind(this))
      .on('select2:unselect', this.clearName.bind(this));

    this.filterNameInputValue = this.filterNameInput.value;
    this.filterLocationInputValue = this.filterLocationInput.value;
  }

  clearLocation() {
    if (this.filterNameInputValue === this.filterNameInput.value) {
      return;
    }

    this.filterNameInputValue = this.filterNameInput.value;

    this.filterLocationInput.value = '';

    // NOTE: force select2 to refresh and reload options
    jQuery(this.filterLocationInput).trigger('change');
  }

  clearName() {
    if (this.filterLocationInputValue === this.filterLocationInput.value) {
      return;
    }

    this.filterNameInput.value = '';
  }
}
